import React from 'react';
import PropTypes from 'prop-types';

var Collection = function Collection(_ref) {
  var name = _ref.name,
      title = _ref.title,
      adDescription = _ref.adDescription,
      adBackgroundImageUrl = _ref.adBackgroundImageUrl,
      adLogoImageUrl = _ref.adLogoImageUrl,
      adCtaText = _ref.adCtaText,
      url = _ref.url,
      mz = _ref.mz,
      resourceIncluded = _ref.resourceIncluded;
  var dataMz = !!mz;

  if (name === 'maths-mastery') {
    return /*#__PURE__*/React.createElement("div", {
      className: "mb-2"
    }, /*#__PURE__*/React.createElement("a", {
      className: "tes-banner tes-banner--math",
      href: "/teaching-resources/teaching-for-mastery-in-primary-maths",
      "data-mz": dataMz,
      "data-module": mz
    }, /*#__PURE__*/React.createElement("div", {
      className: "tes-banner__container tes-banner__container--math"
    }, resourceIncluded && /*#__PURE__*/React.createElement("p", {
      className: "text text--xxs margin-bottom-xs margin-bottom-none-screen-sm"
    }, "Resource included in"), /*#__PURE__*/React.createElement("h3", {
      className: "heading heading--lg heading--bold margin-bottom-xs"
    }, "Primary Maths Mastery"), /*#__PURE__*/React.createElement("p", {
      className: "text text--discreet"
    }, "Find quality-assured lesson resources by topic, ", /*#__PURE__*/React.createElement("br", {
      className: "hidden-xs"
    }), "learning objective and year group"), /*#__PURE__*/React.createElement("span", {
      className: "tes-btn tes-btn--primary tes-btn--sm"
    }, "View complete collection"))));
  } else if (name === 'teaching-shakespeare') {
    var imgSrc = resourceIncluded ? 'https://duqxiy1o2cbw6.cloudfront.net/tes/app-resource-dynamic-hubs/4c0c70a/dist/img/shakespeare-heading.png' : 'https://duqxiy1o2cbw6.cloudfront.net/tes/app-resource-dynamic-hubs/4c0c70a/dist/img/shakespeare-img.png';
    return /*#__PURE__*/React.createElement("div", {
      className: "mb-2"
    }, /*#__PURE__*/React.createElement("a", {
      href: "/teaching-shakespeare/",
      className: "tes-banner tes-banner--shakespeare",
      "data-mz": dataMz,
      "data-module": mz
    }, /*#__PURE__*/React.createElement("div", {
      className: "tes-banner__container tes-banner__container--shakespeare"
    }, /*#__PURE__*/React.createElement("img", {
      className: "tes-banner__img img-responsive center-block",
      src: imgSrc,
      alt: "Teaching Shakespeare"
    }), /*#__PURE__*/React.createElement("p", {
      className: "text text--discreet margin-bottom-md"
    }, "Discover inspiring resources for bringing ", /*#__PURE__*/React.createElement("br", {
      className: "hidden-xs"
    }), "Shakespeare\u2019s work to life"), /*#__PURE__*/React.createElement("span", {
      className: "tes-btn tes-btn--primary tes-btn--sm"
    }, "View complete collection"))));
  }

  if (!url || !adDescription || !title && !adLogoImageUrl) return null;
  var displayTitle = adLogoImageUrl ? /*#__PURE__*/React.createElement("img", {
    className: "img-responsive center-block margin-top-bottom-xs",
    src: adLogoImageUrl,
    alt: title,
    width: "170",
    height: "23"
  }) : /*#__PURE__*/React.createElement("h3", {
    className: "heading heading--lg heading--bold margin-bottom-xs"
  }, title);
  var cta = adCtaText || 'View complete collection'; // Use elements background as gradient for new collections that dont have their own backgrounds

  var backgroundClass = adBackgroundImageUrl ? 'tes-banner' : 'tes-banner tes-banner--elements';
  var backgroundImageStyle = adBackgroundImageUrl ? {
    backgroundImage: "url(".concat(adBackgroundImageUrl, ")"),
    backgroundSize: 'cover'
  } : {};
  return /*#__PURE__*/React.createElement("div", {
    className: "mb-2"
  }, /*#__PURE__*/React.createElement("a", {
    href: url,
    className: backgroundClass,
    style: backgroundImageStyle,
    "data-mz": dataMz,
    "data-module": mz
  }, /*#__PURE__*/React.createElement("div", {
    className: "tes-banner__container l-position-context"
  }, resourceIncluded && /*#__PURE__*/React.createElement("p", {
    className: "text text--xxs margin-bottom-xs margin-bottom-none-screen-sm"
  }, "Resource included in"), displayTitle, /*#__PURE__*/React.createElement("p", {
    className: "text text--discreet"
  }, adDescription), /*#__PURE__*/React.createElement("span", {
    className: "tes-btn tes-btn--primary tes-btn--sm"
  }, cta))));
};

Collection.displayName = "Collection";
Collection.propTypes = {
  url: PropTypes.string,
  adDescription: PropTypes.string,
  title: PropTypes.string,
  name: PropTypes.string,
  adBackgroundImageUrl: PropTypes.string,
  adLogoImageUrl: PropTypes.string,
  adCtaText: PropTypes.string,
  mz: PropTypes.string,
  resourceIncluded: PropTypes.bool
};
export default Collection;